import { memo } from 'react';
import { IconChevronUp } from '@picsart/design-system/foundation/icons/IconChevronUp';
import { useTranslator } from '@picsart/rc/services/localization';

import useStyles from './styles';

const FeedScrollHint = () => {
  const classes = useStyles();
  const translate = useTranslator();

  return (
    <div className={classes.hint} aria-hidden>
      <IconChevronUp fill="currentColor" className={classes.chevron} />
      <span className={classes.label}>{translate('Swipe up for more')}</span>
    </div>
  );
};

export default memo(FeedScrollHint);
